import classNames from "classnames";
import { FC, ReactNode } from "react";
import { default as ReactSelect } from "react-select";
import Colors from "~/constants/colors";
import styles from "./MultipleSelect.module.scss";

interface MultipleSelectItem {
  label: string | ReactNode;
  value: string;
  [x: string]: any;
}

interface MultipleSelectProps {
  label?: string;
  error?: string | false;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  placeHolder?: string;
  options?: MultipleSelectItem[];
  value: any;
  [x: string]: any;
}

const Select: FC<MultipleSelectProps> = ({
  label,
  className,
  error,
  disabled,
  required,
  placeHolder = "Select",
  options,
  value,
  ...props
}) => {
  return (
    <div
      id={props.id}
      className={classNames(styles.select_container, className, {
        [styles.disabled]: disabled,
      })}
    >
      {label ? (
        typeof label === "string" ? (
          <label
            className={classNames(styles.input_label, {
              [styles.required]: required,
            })}
          >
            {label}
          </label>
        ) : (
          label
        )
      ) : null}
      <ReactSelect
        value={value || []}
        className={styles.select}
        options={options}
        classNamePrefix="select"
        placeholder={placeHolder}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderRadius: 8,
            outline: "none",
            boxShadow: "none",
            borderColor: state.isFocused ? Colors.PRIMARY : Colors.GREY_100,
          }),
        }}
        isMulti
        {...props}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default Select;
